import {Stack, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import {
    validateMaxLength,
    validateRequired
} from "../../../components/formValidation/validators";
import CustomTextField from "../../../components/formValidation/CustomTextField";
import CustomTinyMCE from "../../../components/formValidation/CustomTinyMce";
import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingForm";

const PopupData = ({reference, obj}) => {
    const [data, setData] = useState({
        name: obj?.name || '',
        description: obj?.description || '',
    })

    const [errors, setErrors] = useState({
        name: false,
        description: false,
    })

    const validators = {
        name: [validateRequired, value => validateMaxLength(255, value)],
        description: [validateRequired]
    }

    return <ErrorHandlingForm reference={reference} errors={errors} data={data} setData={setData} setErrors={setErrors} validators={validators}>
        <Stack spacing={2}>
            <Typography variant='caption' color='primary.main'>Név*</Typography>
            <CustomTextField
                validators={validators}
                setErrors={setErrors}
                errors={errors}
                data={data}
                setData={setData}
                name='name'
                variant='standard'
            />
            <Typography variant='caption' color='primary.main'>Leírás*</Typography>
            <CustomTinyMCE
                data={data}
                setData={setData}
                name="description"
                errors={errors}
            />
        </Stack>
    </ErrorHandlingForm>
}

export default PopupData 